import React from 'react';

import { abbreviateNumber } from '@pkg/utils';

import { type EmojiId } from '@app/client/common/structs/emoji/emoji';

import { StyledGroupFollowerGains } from './styles';

interface GroupFollowerGainsProps {
    gainNumber?: number;
    emoji?: EmojiId;
}

const GroupFollowerGains = ({ gainNumber = 0, emoji = '🔥' }: GroupFollowerGainsProps) => {
    return (
        <StyledGroupFollowerGains>
            +{abbreviateNumber(gainNumber)} Last 7 days {emoji}
        </StyledGroupFollowerGains>
    );
};

export default GroupFollowerGains;
